import actions from './constants';

export const navigateTo = (url) => ({
  type: actions.NAVIGATE_TO,
  url,
});

export const showAbout = (show) => ({
  type: actions.SHOW_ABOUT,
  show,
});
